export default "__VITE_ASSET__FqsNMTuZ__"